import formatPromoScheduleOption from './formatPromoScheduleOption'
import {
  PROMO_SCHEDULE_STATUS_SORT_ORDER,
  resolvePromoTypeLabel,
  resolvePromoTypeVariant,
} from './promoScheduleConstants'

const countPromoProducts = (products = []) => {
  const list = Array.isArray(products) ? products : []

  return {
    productsTotal: list.length,
    productsMatched: list.filter((product) => product?.matchStatus === 'matched').length,
  }
}

export const mapPromoScheduleListItem = (id, data, now = new Date()) => {
  const schedule = { id, ...data }
  const formatted = formatPromoScheduleOption(schedule, now)
  const { productsTotal, productsMatched } = countPromoProducts(schedule.products)

  return {
    id,
    cashboxScheduleId: schedule.cashboxScheduleId ?? null,
    cashboxScheduleName: schedule.cashboxScheduleName?.trim() || formatted.title,
    brandId: schedule.brandId ?? null,
    promoType: schedule.promoType ?? null,
    promoTypeLabel: resolvePromoTypeLabel(schedule.promoType),
    promoTypeVariant: resolvePromoTypeVariant(schedule.promoType),
    status: formatted.status,
    dateRangeLabel: formatted.dateRangeLabel,
    productsTotal,
    productsMatched,
    productsLabel: productsTotal > 0 ? `${productsMatched} / ${productsTotal}` : '—',
    created: schedule.created ?? null,
    createdAtSort: schedule.created?.seconds || 0,
    updated: schedule.updated ?? null,
    statusSort: PROMO_SCHEDULE_STATUS_SORT_ORDER[formatted.status] ?? 99,
    startedAtSort: schedule.startedAt || '',
  }
}

export default mapPromoScheduleListItem
